document.addEventListener('DOMContentLoaded', function () {
  // Smooth scrolling for alphabet navigation
  const links = document.querySelectorAll('.alphabet-link');
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 20,
          behavior: 'smooth',
        });
      }
    });
  });

  // Search functionality
  const searchInput = document.querySelector('.search-box input');
  const designerNames = document.querySelectorAll('.designer-names li');
  const sections = document.querySelectorAll('.designer-section');

  const updateSectionsVisibility = () => {
    sections.forEach(section => {
      const visibleDesigners = section.querySelectorAll('li:not([style="display: none;"])');
      if (visibleDesigners.length > 0) {
        section.style.display = 'block'; // Show section if it has visible designers
      } else {
        section.style.display = 'none'; // Hide section if no visible designers
      }
    });
  };

  const highlightMatches = (element, query) => {
    const link = element.querySelector('a'); // Keep the link intact
    const text = link.textContent; // Get the original text
    const regex = new RegExp(`(${query})`, 'gi'); // Create a regex to match the query, case-insensitive
    const highlightedText = text.replace(regex, '<strong>$1</strong>'); // Wrap matches in <strong> tags
    link.innerHTML = highlightedText; // Update the link's inner HTML with the highlighted text
  };

  const resetHighlights = () => {
    designerNames.forEach(designer => {
      const link = designer.querySelector('a');
      link.innerHTML = link.textContent; // Restore the original link text
    });
  };

  // Initial visibility check on page load
  updateSectionsVisibility();

  // Handle input for search functionality
  searchInput.addEventListener('input', function (e) {
    const query = e.target.value.toLowerCase();

    // Reset highlights before applying new ones
    resetHighlights();

    // Filter designer names based on search input and highlight matches
    designerNames.forEach(designer => {
      const designerText = designer.textContent.toLowerCase();
      if (designerText.includes(query)) {
        designer.style.display = 'block'; // Show matching designers
        highlightMatches(designer, query); // Highlight matching letters
      } else {
        designer.style.display = 'none'; // Hide non-matching designers
      }
    });

    // Update sections visibility after search
    updateSectionsVisibility();
  });
});
